import { memo, useEffect } from 'react';
import { useLocation } from 'wouter';

import { useClientProfile, useSessionLocation } from 'store';
import useClientUpdates from 'utils/clientUpdates';

const TopLevelHooks = memo(() => {
  // subscribe to location updates
  const [, updateSessionLocation] = useSessionLocation();
  const [location] = useLocation();

  useEffect(() => {
    updateSessionLocation(location);
  }, [location, updateSessionLocation]);

  // subscribe to client profile updates
  const [data, { updateClient }] = useClientProfile();
  useClientUpdates(updateClient, data.sessionToken);

  return null;
});

export default TopLevelHooks;
